import { Table } from '@dreryk/react-components';

import { useIssuedInvoiceDataConfiguration, useIssuedInvoicesTableColumns } from './IssuedInvoicesTable.hooks';
import { StyledIssuedInvoicesTable } from './IssuedInvoicesTable.styled';
import { IssuedInvoicesTableEmptyStatePlaceholder } from './IssuedInvoicesTableEmptyStatePlaceholder';

const ISSUED_INVOICES_TABLE_PAGE_SIZE = 25;

export const IssuedInvoicesTable = (): JSX.Element => {
   return (
      <StyledIssuedInvoicesTable>
         <Table
            columns={useIssuedInvoicesTableColumns()}
            dataConfiguration={useIssuedInvoiceDataConfiguration()}
            keyExtractor={'number'}
            testId={'issuedInvoicesTable'}
            placeholder={<IssuedInvoicesTableEmptyStatePlaceholder />}
            pageSize={ISSUED_INVOICES_TABLE_PAGE_SIZE}
         />
      </StyledIssuedInvoicesTable>
   );
};
